module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Тест")]), _vm._v(" "), _c('div', {
    staticClass: "text-container text-container__result valign"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "result-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Лучше иметь «БАКТИСТАТИН»\n                    под рукой для себя или увлекающихся BBQ близких.")]), _vm._v(" "), _c('span', [_vm._v("узнать больше")]), _c('Arrow')], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("далее")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-top"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Неплохой результат!")]), _vm._v(" "), _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Вы сможете провести почти два месяца BBQ сезона без последствий для кишечника. Однако, потом вам все равно потребуется период восстановления.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-right"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b5b903"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Result.vue
// module id = 103
// module chunks = 0